import React, { Component, createRef } from 'react';
import { MenuItem, Menu } from '@material-ui/core';

export default class WebPicker extends Component {
  constructor(props) {
    super(props);

    //figure out function for this.map
    if(typeof(this.props.mapping) == 'function')
      this.map = this.props.mapping;
    else if(typeof(this.props.mapping) == 'object')
      this.map = v => this.props.mapping[v] || v;
    else
      this.map = v => v;


    this.inputRef = createRef(null);
    this.state = {
      showMenu: false,
      anchorEl: undefined,
      selection: this.props.selectedValue || this.props.values[0],
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleClose = this.handleClose.bind(this);
  }

  componentDidMount() {
    if (this.props.openOnLoad && this.inputRef.current) {
      this.inputRef.current.click();
    }
  }

  handleClick(event) {
    this.setState({ anchorEl: event.currentTarget });
  }

  handleClose(selection) {
    this.setState(selection !== undefined ? { anchorEl: undefined, selection } : { anchorEl: undefined });
    if (selection !== undefined) {
      this.props.onValueChange(selection);
    }
  }

  //this makes reverts work
  static getDerivedStateFromProps(props, state) {
    return { ...state, selection: props.selectedValue };
  }

  getMenuItemStyle(value) {

    let menuItemStyle = {...this.props.menuItemStyle};

    if (this.props.disabledValues && this.props.disabledValues.includes(value)) {
      menuItemStyle = {...menuItemStyle, fontStyle: 'italic', color: '#7b7b7b', pointerEvents: 'none' };
    }
    return menuItemStyle;
  }

  render() {
    let menuItems = this.props.values;
    if (this.props.hiddenOptions) {
      menuItems = this.props.values.filter((v) => !this.props.hiddenOptions.includes(v));
    }

    return (
      <React.Fragment>
        <div
          aria-controls={this.props.id}
          aria-haspopup="true"
          style={{
            userSelect: 'none',
            fontSize: '20px',
            cursor: 'pointer',
            ...this.props.style,
            ...(this.state.anchorEl ? this.props.activeStyle : {}),
          }}
          onClick={this.handleClick}
          ref={this.inputRef}
          className={this.props.className}
        >
          {this.props.dropdownImg || this.map(this.state.selection)}
        </div>
        <Menu
          id={this.props.id}
          anchorEl={this.state.anchorEl}
          keepMounted
          open={Boolean(this.state.anchorEl)}
          onClose={() => this.handleClose(undefined)}
          getContentAnchorEl={null}
          anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
          transformOrigin={{ vertical: 'top', horizontal: 'left' }}
          PaperProps={{style: {maxHeight: this.props.maxHeight || '100%'}}}
        >
          {menuItems.map((v) => <MenuItem key={v} onClick={() => this.handleClose(v)} style={this.getMenuItemStyle(v)}>
            {this.map(v)}
          </MenuItem>)}
        </Menu>
      </React.Fragment>
    );
  }
}
